import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import DayPickModel from '@app/models-internal/day-pick-model';


@Component({
    selector: "day-of-week-picker",
    templateUrl: "./day-of-week-picker.component.html",
    styleUrls: ["./day-of-week-picker.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class DayOfWeekPickerComponent implements OnInit {
  private readonly _componentName = 'DayOfWeekPickerComponent';

  private _days: DayPickModel[] = [
    {
      abbreviation: 'Su',
      selected: false,
      name: 'Sunday'
    },
    {
      abbreviation: 'M',
      selected: false,
      name: 'Monday'
    },
    {
      abbreviation: 'Tu',
      selected: false,
      name: 'Tuesday'
    },
    {
      abbreviation: 'W',
      selected: false,
      name: 'Wednesday'
    },
    {
      abbreviation: 'Th',
      selected: true,
      name: 'Thursday'
    },
    {
      abbreviation: 'F',
      selected: false,
      name: 'Friday'
    },
    {
      abbreviation: 'Sa',
      selected: false,
      name: 'Saturday'
    }
  ];

  public get days(): DayPickModel[] {
    return this._days;
  }
  public set days(v: DayPickModel[]) {
    this._days = v;
  }

  constructor() {}

  ngOnInit() {
    console.log(`${this._componentName}.ngOnInit()`);
  }

  public onCheckBoxChange(day: DayPickModel, evt: Event) {
    // console.log(`${this._componentName}.onCheckBoxChange day=`, day);

    // console.log(`${this._componentName}.onCheckBoxChange evt=`, evt);

    day.selected = !day.selected;

    // console.log(`${this._componentName}.onCheckBoxChange days=`, this.days);
  }

  public onClickAll() {
    this.days.forEach(e => {
      e.selected = true;
    });
  }

  public onClickNone() {
    this.days.forEach(e => {
      e.selected = false;
    });
  }
}
